import { client } from "./API";

const DashboardDetailsService = {
  async getParticularDashboardDetails(
    userId: number,
    isFunnel: boolean
  ) {
    const url = `${isFunnel ? "Project/GetFunnelDetails" : "Project/GetDashboardDetails"
      }/${userId}`;
    const response = await client({
      url: url,
      method: "get",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
};

export default DashboardDetailsService;
